import { render, staticRenderFns } from "./HomepageKYC.vue?vue&type=template&id=4a7e46f2&scoped=true&"
import script from "./HomepageKYC.vue?vue&type=script&lang=js&"
export * from "./HomepageKYC.vue?vue&type=script&lang=js&"
import style0 from "./HomepageKYC.vue?vue&type=style&index=0&id=4a7e46f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7e46f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a7e46f2')) {
      api.createRecord('4a7e46f2', component.options)
    } else {
      api.reload('4a7e46f2', component.options)
    }
    module.hot.accept("./HomepageKYC.vue?vue&type=template&id=4a7e46f2&scoped=true&", function () {
      api.rerender('4a7e46f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/HomepageKYC.vue"
export default component.exports